import { createTheme } from "@mui/material";

// colors
export const primaryColor = "#1677ff";
export const secondaryColor = "#133559";

export const themeMui = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontSize: 14,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 14,
        },
      },
    },
  },
});

export const antdTheme = {
  token: {
    // colorPrimary: primaryColor,
  },
};
